import React from 'react';
import { connect } from 'redux-bundler-react';

class PermalinkModal extends React.Component {
  constructor(props){
    super(props);
    this.close = this.close.bind(this);
    this.constructQueryString = this.constructQueryString.bind(this);
  }

  close() {
    const { doCloseModalWindow } = this.props;
    doCloseModalWindow();
  }

  constructQueryString(){
    const { viewState, visibleCmLayers, windowLocationOrigin: origin, windowLocationPathname: pathname, openProjects } = this.props;
    const url = `${origin}${pathname}?`;
    const paramPairs = [];

    if(visibleCmLayers.length) paramPairs.push(`layers=${visibleCmLayers.join(',')}`);

    const dsLibrary =[];
    if(Object.keys(openProjects.SIMDAMS).length > 0 || Object.keys(openProjects.NID).length >0) {
      const sdLibrary =Object.keys(openProjects.SIMDAMS);
      const iLibrary = Object.keys(openProjects.NID);
      if(sdLibrary.length) {
        const sdLibraryArr =[]
        for(let i=0; i<sdLibrary.length;i++) {
          const obj =openProjects.SIMDAMS[sdLibrary[i]];
          const name = `SIMDAMS-${obj.LIBRARY_ID}`
          sdLibraryArr.push(name)
        }
        if(sdLibraryArr.length) dsLibrary.push(sdLibraryArr.join(','))
      }
      if(iLibrary.length) {
        const iLibraryArr =[]
        for(let i=0; i<iLibrary.length;i++) {
          const obj =openProjects.NID[iLibrary[i]];
          const name = `NID-${obj.id}`
          iLibraryArr.push(name)
        }
        if(iLibraryArr.length) dsLibrary.push(iLibraryArr.join(','))
      }
    }
    if(dsLibrary.length) paramPairs.push(`dsLibrary=${dsLibrary.join(',')}`);

    paramPairs.push(`x=${Math.round(viewState.center[0] * 1000) / 1000}`);
    paramPairs.push(`y=${Math.round(viewState.center[1] * 1000) / 1000}`);
    paramPairs.push(`z=${Math.round(viewState.zoom)}`);

    return `${url}${paramPairs.join('&')}`;
  }

  render() {
    const { theme } = this.props;
    const url = this.constructQueryString();
    return (
      <div>
        <div className={"modal-header " + theme}>
          Copy Permalink
        </div>
        <div
          className="modal-body"
          style={{ height: 200, top: 0, bottom: 0, left: 0, right: 0 }}
        >
          <p>
            Copy the link below to send a permalink to other users or save for later use.
          </p>
          <p>
            The query parameters at the end of the link are used to configure the map so that it zooms to a location or turns layers on.
          </p>
          <p>
            <strong>
              <a href={url}>
                { url }
              </a>
            </strong>
          </p>
          <p>
            Right click the link above, choose "Copy Link Address"
          </p>
        </div>
        <div className="modal-footer">
          <button className={"btn btn-theme " + theme} onClick={this.close}>
            Close
          </button>
        </div>
      </div>
    )
  }
}

export default connect(
  'selectTheme',
  'selectViewState',
  'selectVisibleCmLayers',
  'selectOpenProjects',
  'selectWindowLocationOrigin',
  'selectWindowLocationPathname',
  'doCloseModalWindow',
  PermalinkModal
)